var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBody(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5931 15.6141C29.9987 14.217 29.9987 11.9519 28.5931 10.5548C27.1876 9.15776 24.9086 9.15776 23.5031 10.5548C22.0975 11.9519 22.0975 14.217 23.5031 15.6141C24.9086 17.0112 27.1876 17.0112 28.5931 15.6141Z",
    stroke: "#303587",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9704 19.7978L31.7035 17.0235C31.3802 16.8804 31.0204 16.8387 30.6725 16.9042C24.663 18.0345 37.7947 15.5646 23.2423 18.3017C22.8803 18.3698 22.5496 18.5503 22.2977 18.8172L17.4689 23.9362C16.843 24.5997 16.8438 25.6316 17.4708 26.2941L23.6462 32.8197C23.988 33.181 24.4497 33.3634 24.9126 33.3634C25.0207 33.3634 25.1289 33.3532 25.2358 33.3332L25.468 34.5495L24.4739 50.4598C24.4027 51.5999 25.2764 52.5815 26.4252 52.6522C26.4692 52.6549 26.5127 52.6563 26.5562 52.6563C27.6483 52.6563 28.566 51.8124 28.6345 50.7159C29.7251 33.1457 29.6657 33.9056 29.6657 33.9056L30.5973 33.7304C30.5973 33.7304 31.3122 45.88 31.6084 50.7159C31.6769 51.8124 32.5945 52.6563 33.6866 52.6563C33.7301 52.6563 33.7738 52.6549 33.8177 52.6522C34.9665 52.5815 35.8402 51.5999 35.7689 50.4598C35.6955 48.6011 34.5709 32.9829 34.5709 32.9829L34.3097 31.6243C34.9632 31.5678 35.5565 31.1448 35.7938 30.4921L38.8966 21.9566C39.2053 21.1075 38.8012 20.1656 37.9704 19.7978V19.7978ZM21.1178 25.1123L23.2365 22.8663L24.3098 28.4853L21.1178 25.1123ZM33.4031 26.9097L32.2769 21.0521L35.0813 22.2936L33.4031 26.9097Z",
    stroke: "#303587",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBody);
export default __webpack_public_path__ + "static/media/icon_body.89dab18fda2926326ab886ed5a4aa8e4.svg";
export { ForwardRef as ReactComponent };